import { createContext } from "react";

import { useNonNullableContext } from "app/common";

import type { IMetricWidgetContextValue } from "./types";

export const MetricWidgetContext = createContext<IMetricWidgetContextValue | null>(null);
MetricWidgetContext.displayName = "MetricWidgetContext";

export const useMetricWidgetContext = () => useNonNullableContext(MetricWidgetContext);
